import { PrintConfig } from "./types";

// ─── Default printConfig structure ───────────────────────────────────────────
export const DEFAULT_PRINT_CONFIG: PrintConfig = {
  logo: {
    show: true,
    width: 30,
    height: 20,
    alignment: "center",
  },
  orgDetails: {
    name: "iMetanic pvt. ltd.",
    arabicName: "منظمتي",
    locationRelativeToLogo: "below",
    fontSize: 16,
    fontFamily: "Arial",
    bold: true,
    alignment: "center",
    italic: false,
    showLocation: true, // Default: show location
    showPhone: true, // Default: show phone number
  },
  fontStyles: {
    baseFontSize: 12,
    headerFontSize: 14,
    fontFamily: "Arial",
    labelBold: true,
    amountsBold: true,
    productNameBold: false,
  },
  customerDetails: {
    fields: [
      { key: "customerName", label: "Customer Name", show: true, alignment: "left" },
      { key: "customerPhone", label: "Phone Number", show: true, alignment: "left" },
      { key: "clientId", label: "Client ID", show: false, alignment: "left" },
    ],
  },
  orderDetails: {
    fontSize: 11,
    fields: [
      { key: "orderId", label: "Order ID", show: true, alignment: "left" },
      { key: "billNo", label: "Bill No", show: true, alignment: "right" },
      { key: "status", label: "Status", show: true, alignment: "left" },
      { key: "date", label: "Date", show: true, alignment: "right" },
      { key: "time", label: "Time", show: true, alignment: "left" },
      { key: "paymentMethod", label: "Payment Method", show: true, alignment: "right" },
      { key: "deliveryType", label: "Delivery Type", show: true, alignment: "left" },
    ],
  },
  productList: {
    layout: "table",
    showDiscount: true,
    showUom: true,
    showAddons: false,
    parcelFeeEnabled: false,
    columns: [
      { key: "no", label: "#", show: true, alignment: "left" },
      { key: "name", label: "Product Name", show: true, alignment: "left" },
      { key: "arabic", label: "Arabic Name", show: false, alignment: "right" },
      { key: "qty", label: "Qty", show: true, alignment: "center" },
      { key: "rate", label: "Rate", show: true, alignment: "right" },
      { key: "discount", label: "Disc", show: true, alignment: "right" },
      { key: "total", label: "Total", show: true, alignment: "right" },
    ],
  },
  termsConditions: {
    show: false,
    english: "",
    arabic: "",
    fontSize: 9,
    alignment: "left",
  },
  qrCodes: {
    contact: { show: true, size: 25, alignment: "center", label: "Contact Us" },
    location: { show: true, size: 25, alignment: "center", label: "Find Us" },
    sideBySide: true,
    showLabels: true,
  },
  thankYouNote: {
    show: true,
    english: "Thank you for your business!",
    arabic: "شكراً لتعاملكم معنا",
    fontSize: 11,
    alignment: "center",
    bold: true,
    italic: false,
  },
  brandStamp: {
    show: false,
    text: "PAID",
    size: 25,
    color: "#1a73e8",
    alignment: "center",
  },
};

export const FONT_FAMILIES: string[] = ["Arial", "Courier New", "Times New Roman", "Helvetica", "Georgia", "Verdana"];
export const ALIGNMENTS: Array<"left" | "center" | "right"> = ["left", "center", "right"];
export const STAMP_COLORS: string[] = ["#1a73e8", "#d32f2f", "#388e3c", "#6a1b9a", "#e65100", "#37474f"];
